import { Paper, styled } from "@mui/material";

import { useTagsContext } from "hooks/routerHooks";

import { Tag } from "./Tag";

export default function TagSection() {
  const { tags } = useTagsContext();


  return (
    <StyledPaper elevation={0}>
      {tags.treeTags.map((tag) => (
        <Tag tag={tag} key={tag.id} />
      ))}
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  flex-wrap: wrap;
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  padding-top: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  padding-left: ${({ theme }) => theme.spacing(3)};
  padding-right: ${({ theme }) => theme.spacing(3)};
`;
